import styled from '@emotion/styled/macro';
import { Variables } from '../base';

const NOTCH_PX = 16;

export const SectionLabel = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
`;

export const JourneyContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ChevronRow = styled.ol`
    display: flex;
    gap: 4px;
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const ChevronCell = styled.li<{ $first: boolean }>`
    position: relative;
    flex: 1;
    min-width: 0;
    margin-left: ${({ $first }) => ($first ? 0 : `-${NOTCH_PX}px`)};
`;

const clipPath = (first: boolean, last: boolean): string => {
    if (last) {
        return `polygon(0 0, 100% 0, 100% 100%, 0 100%, ${NOTCH_PX}px 50%)`;
    }
    if (first) {
        return `polygon(0 0, calc(100% - ${NOTCH_PX}px) 0, 100% 50%, calc(100% - ${NOTCH_PX}px) 100%, 0 100%)`;
    }
    return `polygon(0 0, calc(100% - ${NOTCH_PX}px) 0, 100% 50%, calc(100% - ${NOTCH_PX}px) 100%, 0 100%, ${NOTCH_PX}px 50%)`;
};

export const Chevron = styled.div<{
    $first: boolean;
    $last: boolean;
    $background: string;
    $border: string;
}>`
    display: flex;
    align-items: center;
    gap: 10px;
    height: 62px;
    padding: 0 ${({ $last }) => ($last ? 16 : NOTCH_PX + 12)}px 0 ${({ $first }) => ($first ? 16 : NOTCH_PX + 12)}px;
    background: ${({ $background }) => $background};
    border: 1px solid ${({ $border }) => $border};
    clip-path: ${({ $first, $last }) => clipPath($first, $last)};
`;

export const ChevronIcon = styled.span<{ $color: string }>`
    display: inline-flex;
    flex: none;
    color: ${({ $color }) => $color};

    svg {
        fill: currentColor;
    }
`;

export const ChevronText = styled.span`
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
`;

export const ChevronLabel = styled.span<{ $muted: boolean }>`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ${Variables.Fonts.calibre};
    font-size: 13px;
    font-weight: 600;
    line-height: 1.15;
    color: ${({ $muted }) => ($muted ? Variables.ThemeLight.TextMild : Variables.ThemeLight.TextStrong)};
`;

export const ChevronCaption = styled.span<{ $color: string }>`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ${Variables.Fonts.calibre};
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${({ $color }) => $color};
`;
